import React, { Component } from "react";
import { Done } from "@material-ui/icons";

export const SuccesCheck = () => {
  return (
    <div style={{ width: "80px",
    height: "80px",
    margin:" 0 auto"}}>
    <button className="btn btn-rounded-circle btn-outline-success" style={{borderRadius:"50%", width: "80px", height: "80px"}}>
      <Done fontSize="large"/>
    </button>
  </div>
  );
};
